import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'HolidayMessagingLazy',
        path: () => path.join(__dirname, './HolidayMessaging'),
        resolve: () => require.resolveWeak('./HolidayMessaging'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "HolidayMessagingLazy" */ './HolidayMessaging'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
